import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";
import { linkedProjectPlansColumns } from "./columns";
import Table from "../../../../../../components/table/table";
import { Button } from "../../../../../../components/button/button";
import { LinkedPlanStyled } from "./linked-plan.style";
import ChartContext from "../../../../../../context/ChartContext";
import { EncircledPlusIcon } from "../../../../../../utils/svg-components";
import { formatNumber } from "../../../../../../utils/utils";
import {
  exportEstimate,
  exportTimeline,
  exportGantt,
} from "../utils/pdfExportUtils";

const LinkedProjectPlansTable = ({
  projectData,
  companyDetails,
  companyName,
  isGeneralUser,
  contactName,
}) => {
  const { exportGanttChart } = useContext(ChartContext);

  // const materialsBudget = projectData?.materials?.[0]?.budget || 0;
  const materialsBudget = projectData?.materials?.reduce(
    (sum, mat) => sum + parseFloat(mat.total || 0),
    0
  );
  const projectTotal = projectData?.projectTotal || 0;

  // Check if there is any data in timelines
  const hasTimelineData =
    projectData?.deliverables &&
    Object.keys(projectData.deliverables).length > 0;

  const tableData = hasTimelineData
    ? [
        {
          ...projectData,
          companyName,
          materials: formatNumber(materialsBudget),
          projectTotal: parseFloat(projectTotal),
        },
      ]
    : [];

  const navigate = useNavigate();

  const handleCreateProjectPlan = () => {
    if (isGeneralUser) {
      alert("You do not have permission to create a project plan!");
    } else {
      navigate(`/projectsview/${projectData.id}/planner`);
      window.location.reload();
    }
  };
  const exportEstimatePDF = () =>
    exportEstimate({ projectData, companyDetails, contactName });

  const exportSimpleEstimatePDF = () =>
    exportEstimate({
      projectData,
      companyDetails,
      contactName,
      forceFFP: true,
    });

  const exportTimelinePDF = () => {
    exportTimeline({ projectData, companyDetails, contactName });
  };
  const exportSimpleTimelinePDF = () =>
    exportTimeline({
      projectData,
      companyDetails,
      contactName,
      forceSimple: true,
    });

  const noDataMessage = (
    <div className="no-data-message">
      <Typography variant="body4">
        There is no plan associated with this project.
      </Typography>

      {!isGeneralUser && (
        <Button
          variant="filled"
          color={"tertiary"}
          startIcon={<EncircledPlusIcon />}
          onClick={handleCreateProjectPlan}
        >
          Create Project Plan
        </Button>
      )}
    </div>
  );
  return (
    <LinkedPlanStyled>
      <div className="plans">
        <Typography variant="h6"> Project Plan</Typography>
        <Table
          data={tableData}
          noDataMessage={noDataMessage}
          columns={linkedProjectPlansColumns(
            projectData,
            exportEstimatePDF,
            exportTimelinePDF,
            exportSimpleEstimatePDF,
            exportSimpleTimelinePDF,
            isGeneralUser
          )}
        />
      </div>
    </LinkedPlanStyled>
  );
};

export default LinkedProjectPlansTable;
